import { useMemo } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import RateSummaryRow from './RateSummaryRow';
import { dateFormat, parseDate } from 'src/utils/dateFormat';
import { createRateRow } from 'src/utils/rateCalculations';
import { useSelector } from 'react-redux';
import { ReservationType } from 'src/utils/constants';

const RateSummarySection = ({
  roomData,
  roomIndex,
  hotelData,
  unitData,
  unitIndex,
  serviceData,
}) => {
  const { reservationOverview } = useSelector(
    (state) => state.reservationsSummaryReducer
  );

  const rateSummaryData = useMemo(() => {
    const data = [];

    // Hotel Room Rates + Supplements + Discounts
    if (roomData && hotelData) {
      roomData.RoomRates?.forEach((rate) => {
        data.push(
          createRateRow(
            rate,
            reservationOverview,
            roomData,
            hotelData,
            roomIndex + 1,
            'RoomRate',
            'hotel',
            roomData.RoomType || 'RoomRate',
            parseDate,
            dateFormat,
            roomData.RoomId
          )
        );
      });

      roomData.SupplementRates?.forEach((sup) => {
        data.push(
          createRateRow(
            sup,
            reservationOverview,
            roomData,
            hotelData,
            roomIndex + 1,
            'Supplement',
            'hotel',
            sup.RateType || 'Supplement',
            parseDate,
            dateFormat,
            sup.SupplementId
          )
        );
      });

      roomData.DiscountRates?.forEach((dis) => {
        data.push(
          createRateRow(
            dis,
            reservationOverview,
            roomData,
            hotelData,
            roomIndex + 1,
            'Discount',
            'hotel',
            dis.RateType || 'Discount',
            parseDate,
            dateFormat,
            dis.DiscountId
          )
        );
      });
    }

    // Service Unit Rates
    if (unitData && serviceData) {
      unitData.ServiceUnitRates?.forEach((rate) => {
        data.push(
          createRateRow(
            rate,
            reservationOverview,
            unitData,
            serviceData,
            unitIndex + 1,
            'Service',
            'service',
            'RoomRate',
            parseDate,
            dateFormat
          )
        );
      });

      unitData.SupplementRates?.forEach((sup) => {
        data.push(
          createRateRow(
            sup,
            reservationOverview,
            unitData,
            serviceData,
            unitIndex + 1,
            'Supplement',
            'service',
            sup.RateType || 'Supplement',
            parseDate,
            dateFormat
          )
        );
      });

      unitData.DiscountRates?.forEach((dis) => {
        data.push(
          createRateRow(
            dis,
            reservationOverview,
            unitData,
            serviceData,
            unitIndex + 1,
            'Discount',
            'service',
            dis.RateType || 'Discount',
            parseDate,
            dateFormat
          )
        );
      });
    }
    

    return data;
  }, [
    roomData,
    roomIndex,
    hotelData,
    unitData,
    unitIndex,
    serviceData,
    reservationOverview,
  ]);

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f7fa' }}>
              <TableCell sx={{ fontWeight: 600, width: 60 }} />
              <TableCell sx={{ fontWeight: 600 }}>
                {rateSummaryData.some(row => row.type === ReservationType.hotel)
                  ? 'Room Details'
                  : 'Service Details'}
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Service Period</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">Charge Type</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                {rateSummaryData.some(row => row.type === ReservationType.hotel)
                  ? 'Rooms & Guests'
                  : 'Units & Guests'}
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Buy Rate</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Net Sell</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Net Sell Total</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rateSummaryData.map((row, i) => (
              <RateSummaryRow key={i} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RateSummarySection;